import React from 'react';
import { Link } from 'react-router-dom';
import SlideshowBanner from '../components/SlideshowBanner';

const Home = () => {
  return (
    <div className="min-h-screen">
      <SlideshowBanner />
      
      {/* Featured Services Section */}
      <section className="py-16 px-4 bg-gray-50">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-3xl font-playfair text-center mb-12">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: 'Event Décor',
                description: 'Transform your venue with our elegant décor items',
                imageUrl: '/images/featured/event1.png',
                isComingSoon: true,
                sectionId: 'decor'
              },
              {
                title: 'Chilanga Mulilo',
                description: 'Traditional ceremony equipment and setup services',
                imageUrl: '/images/featured/potslineup.jpg',
                isComingSoon: false,
                sectionId: 'chilanga'
              },
              {
                title: 'Music Systems',
                description: 'Professional sound equipment for any occasion',
                imageUrl: '/images/featured/music.png',
                isComingSoon: false,
                sectionId: 'music-system'
              },
              {
                title: 'Photography Equipment',
                description: 'High-quality cameras and photo booth setups',
                imageUrl: '/images/featured/photo.png',
                isComingSoon: true,
                sectionId: 'photography'
              },
              {
                title: 'Catering Equipment',
                description: 'Professional grade serving and dining equipment',
                imageUrl: '/images/featured/catering.png',
                isComingSoon: true,
                sectionId: 'catering'
              },
              {
                title: 'Full Event Packages',
                description: 'Complete event solutions tailored to your needs',
                imageUrl: '/images/featured/package.png',
                isComingSoon: true,
                sectionId: 'packages'
              }
            ].map((service, index) => (
              <div 
                key={index}
                className="bg-white rounded-lg shadow-lg overflow-hidden transition-transform duration-300 hover:transform hover:scale-105"
              >
                <div className="h-48 overflow-hidden relative">
                  <img 
                    src={service.imageUrl} 
                    alt={service.title}
                    className="w-full h-full object-cover"
                  />
                  {service.isComingSoon && (
                    <div className="absolute top-4 right-4 bg-gold-500 text-white px-3 py-1 rounded-full text-sm font-medium">
                      Coming Soon
                    </div>
                  )}
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-playfair mb-2 text-gray-800">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 font-poppins mb-4">
                    {service.description}
                  </p>
                  {!service.isComingSoon && (
                    <Link
                      to={`/services#${service.sectionId}`}
                      className="text-gold-500 hover:text-gold-600 font-medium transition-colors duration-300"
                    >
                      Learn More →
                    </Link>
                  )}
                </div>
              </div>
            ))}
          </div>
          <div className="text-center mt-12">
            <Link
              to="/services"
              className="inline-block bg-gold-500 text-white font-poppins py-3 px-8 rounded-full hover:bg-gold-600 transition duration-300"
            >
              View All Services
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;